import { render, staticRenderFns } from "./IconYxxgbfjb.vue?vue&type=template&id=8f72cce8"
import script from "./IconYxxgbfjb.vue?vue&type=script&lang=js"
export * from "./IconYxxgbfjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports